class Barba {
  constructor(){
    this.event();
  }
  event(){
    barba.init({
      preventRunning: true,
      transitions: [
        {
          once(data) {
            contentListSwiper(); // Swiperの初期化関数を呼び出す
            detailContentSwiper();
            footerPagenation();
            bgmStart();
            const barbaBody = document.querySelector('.js-barba-body');
            gsap.to(barbaBody, {
              opacity: 1,
              duration: 0.8
            });
            if(data.next.namespace == 'home') {
              homeMvMovieLoop()
            }else {
              backTop(data.next.namespace);
            }
          },
          async leave(data) {
            // フェードアウト
            const container = data.current.container;
            await gsap.to(container, {
              opacity: 0,
              duration: 0.4
            });
          },
          enter(data) {
            // preventRunning: true,で解決したのでコメントアウト
            // $('body').css('pointer-events','none');
            // setTimeout(function(){
            //   $('body').css('pointer-events','');
            // },500)
            if(data.next.namespace === 'list') {
              contentListSwiper(); // Swiperの初期化関数を再度呼び出す
            }
            detailContentSwiper();
            window.scrollTo(0, 0);
          },
          async after(data) {
            // 新しいページのDOMが完全に読み込まれた後の処理
            const container = data.next.container;
            // フェードイン
            await gsap.to(container, {
              opacity: 1,
              duration: 0.4
            });
            footerPagenation();
          },
          afterEnter(data){
            if(data.next.namespace == 'home') {
              homeMvMovieLoop()
            }else {
              backTop(data.next.namespace);
              qrCodeToggle();
            }
          }
        },
      ],
      views: [
        {
          namespace: 'home',
          beforeEnter(data) {
            footerToggle('home')
          }
        },
        {
          namespace: 'about-hyundai',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'mocean',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'ioniq5',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'kona',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'n-brand-story',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'green-action',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'artworks-credit',
          beforeEnter(data) {
            footerToggle('list')
          }
        },
        {
          namespace: 'list',
          beforeEnter(data) {
            footerToggle('list')
          }
        },
      ]
    });
    

    function contentListSwiper() {
      let thisSwiper = new Swiper('.js-content-list-swiper', {
        loop: true, // ループの有効化
        allowTouchMove: false,
        effect: 'fade',
        speed: 1000,
        autoplay: { // 自動再生させる
          delay: 6500, // 次のスライドに切り替わるまでの時間（ミリ秒）
        },
      });
    }

    detailContentSwiper();
    function detailContentSwiper() {
      const swiperWrap = '.js-content-swiper';
      $(swiperWrap).each(function(){
        const thisData = $(this).data('swiper');
        let detailSwiper = new Swiper('[data-swiper="'+thisData+'"] .js-detail-swiper', {
          loop: false, // ループの有効化
          allowTouchMove: false,
          navigation: {
            nextEl: '[data-swiper="'+thisData+'"] .swiper-next',
            prevEl: '[data-swiper="'+thisData+'"] .swiper-prev',
          },
          pagination: {
            el: '[data-swiper="'+thisData+'"] .swiper-pagination',
            type: 'fraction', // 分数表示を指定
          },
        });
        let thumbSwiper = new Swiper('[data-swiper="'+thisData+'"] .js-thumb-swiper', {
          loop: false, // ループの有効化
          centeredSlides: true,
          slidesPerView: 2.7,
          speed: 500,
          thumbs: {
            swiper: detailSwiper
          },
          on: {
            // サムネイルSwiperのスライド変更時にメインSwiperを更新
            slideChange: function () {
              let newIndex = this.realIndex;
              detailSwiper.slideTo(newIndex);
            },
            init: function () {
              // Swiperの初期化が完了したら、swiper-slideのtransition-durationを変更する
              setTimeout(function(){
                $('.swiper-slide').css('transition', 'all 0.5s');
              },500)
            }
          }
        });
        detailSwiper.on('slideChange', function () {
          let newIndex = this.realIndex;
          thumbSwiper.slideTo(newIndex);
        });
      })
    }

    function footerPagenation() {
      const nextLinkTarget = '.js-pagenation-next';
      const prevLinkTarget = '.js-pagenation-prev';
      const linkWrap = '.js-pagenation';
      const nextLink = $(linkWrap).data('next');
      const prevLink = $(linkWrap).data('prev');
      $(nextLinkTarget).attr('href',nextLink);
      $(prevLinkTarget).attr('href',prevLink);


      // preventRunning: true,で解決したのでコメントアウト
      // $(nextLinkTarget + ', ' + prevLinkTarget).on('click', function(e) {
      //   if ($(this).attr('href') == '#') {
      //     e.preventDefault(); // クリックを防止
      //     return; // 早期リターン
      //   }
      // });
    }

    function footerToggle(target) {
      const toggleElement = '.js-footer-toggle';
      $(toggleElement).each(function() {
        const thisTargets = $(this).data('toggle-active');
        // データ属性を配列として取得（複数の値を想定し、半角スペースで分割）
        const targetsArray = thisTargets.split(' ').filter(item => item.trim() !== '');
        // ターゲットが配列内に存在するかチェック
        if (targetsArray.includes(target)) {
          $(this).removeClass('is-hidden');
        } else {
          $(this).addClass('is-hidden');
        }
      });
    }
    

    // 5分後にTOPページ
    function backTop(page) {
      setupListeners();
      clearTimeout(window.backTopTimeoutId);
    
      window.backTopTimeoutId = setTimeout(() => {
        if(page != 'home'){
          barba.go('/')
        }
      }, 1800000); // 30分
    }
    
    // ユーザーの操作を検出するイベントリスナーを設定
    function setupListeners() {
      const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keydown', 'scroll'];
      events.forEach(event => {
        document.addEventListener(event, resetTimer, false);
      });
    }
    
    function resetTimer() {
      clearTimeout(window.backTopTimeoutId);
      window.backTopTimeoutId = setTimeout(() => {
        barba.go('/');
      }, 1800000); // 30分後にトップページにリダイレクト
    }

    // TOPページの動画ループ
    function homeMvMovieLoop() {
      const videoLooper = new VideoLooper(".js-home-movie"); // video-classはビデオ要素の共通クラス
      videoLooper.playFirstVideo();
    }

    // QRコードの実装
    function qrCodeToggle() {
      const qrModal = new QrModal('js-btn-qr');
    }

    // BGM再生
    function bgmStart() {
      document.addEventListener('click', function () {
        const bgm = document.getElementById('bgm');
        bgm.muted = true; // ブラウザの自動再生ポリシーを回避するために最初はミュート
        bgm.play().then(() => {
            // console.log("自動再生に成功しました");
            bgm.muted = false;
        }).catch(error => {
            // console.log("自動再生に失敗しました", error);
        });
      })
    }

  }
}
